/* Nocna Skora - cart-sync.js
   Resynchronise le compteur et le tiroir/page panier apres tout appel /cart/add|change|update|clear,
   y compris ceux d'apps tierces (Cart-Bot ajoute/retire le produit gratuit avec un leger retard). */
(function () {
  'use strict';
  if (window.__nsCartSync) return;
  window.__nsCartSync = true;
  var origFetch = window.fetch;
  if (!origFetch) return;
  var timers = [];
  var CART_RE = new RegExp('/cart/(add|change|update|clear)');

  function jsonUrl() { return ((window.NS && window.NS.routes) || {}).cart_json || '/cart.js'; }
  function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function domSignature() {
    var host = document.querySelector('[data-cart-content], .cart-page');
    if (!host) return null;
    return Array.prototype.map.call(host.querySelectorAll('.cart-item'), function (li) {
      var input = li.querySelector('[data-qty-input]');
      return li.getAttribute('data-key') + ':' + (input ? input.value : '');
    }).join('|');
  }

  function resync() {
    origFetch.call(window, jsonUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !(cart.item_count > 0); });
        var sig = cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
        var dom = domSignature();
        if (dom === null || dom === sig) return;
        var ids = [];
        qsa('[data-cart-section]').forEach(function (el) {
          var id = el.getAttribute('data-section-id');
          if (id && ids.indexOf(id) === -1) ids.push(id);
        });
        if (!ids.length) return;
        return origFetch.call(window, window.location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            Object.keys(sections || {}).forEach(function (id) {
              var live = document.querySelector('[data-cart-section][data-section-id="' + id + '"]');
              if (!live || !sections[id]) return;
              var doc = new DOMParser().parseFromString(sections[id], 'text/html');
              var fresh = doc.querySelector('[data-cart-section][data-section-id="' + id + '"]');
              if (fresh) live.innerHTML = fresh.innerHTML;
            });
          });
      })
      .catch(function () {});
  }

  function schedule() {
    timers.forEach(clearTimeout);
    timers = [setTimeout(resync, 1200), setTimeout(resync, 3200)];
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (CART_RE.test(url)) { p.then(schedule, function () {}); }
    return p;
  };

  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_RE.test(String(url))) { this.addEventListener('loadend', schedule); }
      return open.apply(this, arguments);
    };
  }
})();
